<template>
    <div class="hpk-home">
        <!-- 欢迎横幅 -->
        <div class="hh-banner">
            <div class="hh-hi">
                <h2>{{ greeting }}，{{ username }}</h2>
                <p>欢迎回到 {{ platform }} · 昨日新增评课 <b>{{ ydNew }}</b> 节，完成率 <b>{{ doneRate }}%</b>，平台运行平稳</p>
            </div>
            <div class="hh-date">
                <div class="big">{{ dateShort }}</div>
                <div class="sub">{{ dateFull }} {{ weekCN }}</div>
            </div>
        </div>

        <!-- KPI 卡 -->
        <div class="hh-kpis">
            <div class="hh-kpi tc-blue">
                <div class="hh-ring">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4fc3ff" stroke-width="2"><path d="M3 12h4l3-8 4 16 3-8h4"/></svg>
                </div>
                <div>
                    <div class="hh-label">累计评课总数</div>
                    <div class="hh-value">{{ lessonTotal }}<small>节</small></div>
                    <div class="hh-trend">近 7 日新增 {{ weekNew }} 节</div>
                </div>
            </div>
            <div class="hh-kpi tc-teal">
                <div class="hh-ring">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#35e0b0" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-4"/></svg>
                </div>
                <div>
                    <div class="hh-label">评课完成率</div>
                    <div class="hh-value">{{ doneRate }}<small>%</small></div>
                    <div class="hh-trend">已完成 {{ doneCount }} / {{ lessonTotal }} 节</div>
                </div>
            </div>
            <div class="hh-kpi tc-amber">
                <div class="hh-ring">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffd24a" stroke-width="2"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10M7 13h7"/></svg>
                </div>
                <div>
                    <div class="hh-label">评课指标 / 标准</div>
                    <div class="hh-value">{{ ruleTotal }}<small>/{{ templateTotal }}</small></div>
                    <div class="hh-trend">覆盖 {{ templateTotal }} 套评课标准</div>
                </div>
            </div>
            <div class="hh-kpi tc-coral">
                <div class="hh-ring">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff8a5c" stroke-width="2"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><circle cx="17" cy="9" r="2.5"/><path d="M15 14.5a5 5 0 0 1 6.5 4.8"/></svg>
                </div>
                <div>
                    <div class="hh-label">参与教师</div>
                    <div class="hh-value">{{ teacherTotal }}<small>人</small></div>
                    <div class="hh-trend">评课覆盖教师 {{ distinctTeachers }} 人</div>
                </div>
            </div>
        </div>

        <!-- 图表行 -->
        <div class="hh-grid">
            <div class="hh-card">
                <div class="hh-title hh-sm">近 7 日评课趋势<span class="more" @click="go('auto')">查看评课管理 ＞</span></div>
                <div ref="trendChart" class="hh-chart"></div>
            </div>
            <div class="hh-card hh-map-card">
                <div class="hh-title hh-sm">院校分布<span class="more">已定位 {{ locatedCount }} / 共 {{ collegeTotal }} 所</span></div>
                <div ref="mapChart" class="hh-chart"></div>
            </div>
            <div class="hh-card">
                <div class="hh-title hh-sm">学科评课占比</div>
                <div ref="subjectChart" class="hh-chart"></div>
            </div>
        </div>

        <!-- 快捷入口 -->
        <div class="hh-title tc-amber">快捷入口</div>
        <div class="hh-entries">
            <div class="hh-entry tc-blue" @click="go('auto')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4fc3ff" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg></div>
                <div class="hh-ename">评课管理</div>
                <div class="hh-enum">{{ lessonTotal }} 节</div>
            </div>
            <div class="hh-entry tc-teal" @click="go('module_rule')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#35e0b0" stroke-width="2"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10M7 13h7"/></svg></div>
                <div class="hh-ename">评课指标库</div>
                <div class="hh-enum">{{ ruleTotal }} 项</div>
            </div>
            <div class="hh-entry tc-amber" @click="go('module')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffd24a" stroke-width="2"><path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14l-8-4-8 4z"/></svg></div>
                <div class="hh-ename">评课标准</div>
                <div class="hh-enum">{{ templateTotal }} 套</div>
            </div>
            <div class="hh-entry tc-purple" @click="go('agent')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" stroke-width="2"><rect x="4" y="4" width="16" height="12" rx="2"/><path d="M8 20h8M12 16v4"/></svg></div>
                <div class="hh-ename">人机协同评课</div>
                <div class="hh-enum">{{ agentTotal }} 个智能体</div>
            </div>
            <div class="hh-entry tc-coral" @click="go('course')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff8a5c" stroke-width="2"><path d="M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5"/></svg></div>
                <div class="hh-ename">课程管理</div>
                <div class="hh-enum">{{ courseTotal }} 门课程</div>
            </div>
            <div class="hh-entry tc-blue" @click="go('subject')">
                <div class="hh-eico"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4fc3ff" stroke-width="2"><path d="M4 19V5a2 2 0 0 1 2-2h13v18H6a2 2 0 0 1-2-2zM4 17h15"/></svg></div>
                <div class="hh-ename">学科管理</div>
                <div class="hh-enum">{{ subjectTotal }} 个学科</div>
            </div>
        </div>

        <!-- 最新动态 -->
        <div class="hh-card">
            <div class="hh-title hh-sm">最新教研动态</div>
            <div class="hh-feed">
                <div class="hh-feed-item" v-for="f in feeds" :key="f.id" :class="'tc-' + f.tone">
                    <span class="dot"></span>
                    <span class="txt">{{ f.teacherName }} 提交评课 <b>「{{ f.title }}」</b><template v-if="f.subjectName">（{{ f.subjectName }}）</template></span>
                    <span class="pill">{{ f.pill }}</span>
                    <span class="time">{{ f.time }}</span>
                </div>
                <div v-if="!feeds.length" class="hh-empty">暂无教研动态</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { lists as lessonLists } from '@/request/api/lession.js'
import { lists as templateLists, rule_lists } from '@/request/api/module.js'
import { lists as subjectLists } from '@/request/api/subject.js'
import { lists as courseLists } from '@/request/api/course.js'
import { lists as agentLists } from '@/request/api/agent.js'
import { page as teacherPage } from '@/request/api/teacher.js'
import { map_dist as collegeMapDist } from '@/request/api/college.js'

const PALETTE = ['#4fc3ff', '#ffd24a', '#35e0b0', '#a78bfa', '#ff8a5c', '#ff6b6b']
const MAX_SAMPLE = 500
// 省份 -> 省会坐标（lng, lat），用于地图散点定位
const PROVINCE_CENTER = {
    北京: [116.41, 39.9], 天津: [117.2, 39.13], 河北: [114.5, 38.04], 山西: [112.55, 37.87],
    内蒙古: [111.67, 40.82], 辽宁: [123.43, 41.8], 吉林: [125.32, 43.9], 黑龙江: [126.53, 45.8],
    上海: [121.47, 31.23], 江苏: [118.78, 32.06], 浙江: [120.15, 30.28], 安徽: [117.28, 31.86],
    福建: [119.3, 26.08], 江西: [115.89, 28.68], 山东: [117.0, 36.65], 河南: [113.65, 34.76],
    湖北: [114.3, 30.6], 湖南: [112.93, 28.23], 广东: [113.28, 23.13], 广西: [108.33, 22.84],
    海南: [110.32, 20.03], 重庆: [106.55, 29.57], 四川: [104.07, 30.57], 贵州: [106.71, 26.57],
    云南: [102.71, 25.04], 西藏: [91.11, 29.97], 陕西: [108.95, 34.27], 甘肃: [103.82, 36.06],
    青海: [101.78, 36.62], 宁夏: [106.28, 38.47], 新疆: [87.62, 43.79], 台湾: [121.52, 25.03],
    香港: [114.17, 22.32], 澳门: [113.55, 22.2],
}
// GeoJSON 全称 -> 简称，用于 visualMap/匹配
function shortProvince(full) {
    return String(full || '')
        .replace('维吾尔自治区', '').replace('壮族自治区', '').replace('回族自治区', '')
        .replace('自治区', '').replace('特别行政区', '').replace('省', '').replace('市', '')
}

export default {
    name: 'HomeWelcome',
    data() {
        return {
            username: this.$store.state.user.username || '管理员',
            platform: (window.mconfig && window.mconfig.name) || '智慧教研平台',
            now: new Date(),
            lessonTotal: 0,
            weekNew: 0,
            ydNew: 0,
            doneCount: 0,
            doneRate: '0.0',
            distinctTeachers: 0,
            trend: { dates: [], counts: [], done: [] },
            subjects: [],
            feeds: [],
            templateTotal: 0,
            ruleTotal: 0,
            subjectTotal: 0,
            courseTotal: 0,
            agentTotal: 0,
            teacherTotal: 0,
        }
    },
    computed: {
        greeting() {
            const h = this.now.getHours()
            if (h < 6) return '凌晨好'
            if (h < 9) return '早上好'
            if (h < 12) return '上午好'
            if (h < 14) return '中午好'
            if (h < 18) return '下午好'
            return '晚上好'
        },
        dateFull() {
            return this.fmtDay(0)
        },
        dateShort() {
            return this.dateFull.slice(5)
        },
        weekCN() {
            return '周' + '日一二三四五六'.charAt(this.now.getDay())
        },
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.loadData()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
        if (this.trendChart) { this.trendChart.dispose(); this.trendChart = null }
        if (this.subjectChart) { this.subjectChart.dispose(); this.subjectChart = null }
    },
    methods: {
        pad(n) {
            return n < 10 ? '0' + n : '' + n
        },
        fmtDay(offset) {
            const d = new Date()
            d.setDate(d.getDate() + offset)
            return d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + this.pad(d.getDate())
        },
        go(name) {
            this.$router.push({ name: name }).catch(function () { })
        },
        onResize() {
            clearTimeout(this._rt)
            this._rt = setTimeout(() => {
                if (this.trendChart) this.trendChart.resize()
                if (this.mapChart) this.mapChart.resize()
                this.renderSubject()
            }, 200)
        },
        async loadData() {
            try {
                const res = await lessonLists({ page: 1, size: MAX_SAMPLE })
                if (res && res.code === 0 && res.data) {
                    this.lessonTotal = Number(res.data.total) || 0
                    this.digestLessons(res.data.list || [])
                }
            } catch (e) {
                // 后端不可达时展示 0，不打断页面
            }
            const that = this
            const cnt = function (p) {
                return p
                    .then(function (r) { return (r && r.code === 0 && r.data && Number(r.data.total)) || 0 })
                    .catch(function () { return 0 })
            }
            Promise.all([
                cnt(templateLists({ page: 1, size: 1 })),
                cnt(rule_lists({ page: 1, size: 1 })),
                cnt(subjectLists({ page: 1, size: 1 })),
                cnt(courseLists({ page: 1, size: 1 })),
                cnt(agentLists({ page: 1, size: 1 })),
                cnt(teacherPage({ page: 1, size: 1 })),
            ]).then(function (arr) {
                that.templateTotal = arr[0]
                that.ruleTotal = arr[1]
                that.subjectTotal = arr[2]
                that.courseTotal = arr[3]
                that.agentTotal = arr[4]
                that.teacherTotal = arr[5]
            })
            this.renderTrend()
            this.renderSubject()
            this.loadCollegeMap()
        },
        // 院校分布地图：并行加载中国 GeoJSON（运行时从 public/map 读取）+ 后端聚合数据
        loadCollegeMap() {
            const that = this
            const geoUrl = (process.env.BASE_URL || '/') + 'map/china.json'
            const geoP = fetch(geoUrl).then(function (r) { return r.json() })
            const dataP = collegeMapDist().catch(function () { return null })
            Promise.all([geoP, dataP]).then(function (arr) {
                const geo = arr[0]
                const res = arr[1]
                if (!geo || !geo.features) return
                echarts.registerMap('china', geo)
                that.chinaReady = true
                if (res && res.code === 0 && res.data) {
                    that.collegeTotal = Number(res.data.total) || 0
                    that.locatedCount = Number(res.data.located) || 0
                    that.digestColleges(res.data.list || [])
                }
                that.renderMap()
            }).catch(function () { /* 地图资源不可达时静默跳过 */ })
        },
        digestColleges(items) {
            const byProvince = {}
            items.forEach(function (it) {
                const p = it.province
                if (!p || !PROVINCE_CENTER[p]) return
                if (!byProvince[p]) byProvince[p] = { lessons: 0, colleges: [] }
                byProvince[p].lessons += Number(it.lessonCount) || 0
                byProvince[p].colleges.push(it.name + '（' + (Number(it.lessonCount) || 0) + ' 节）')
            })
            this.collegeProvinces = Object.keys(byProvince).map(function (p) {
                const c = PROVINCE_CENTER[p]
                return {
                    name: p,
                    value: [c[0], c[1], byProvince[p].lessons],
                    colleges: byProvince[p].colleges,
                }
            })
        },
        renderMap() {
            const el = this.$refs.mapChart
            if (!el || !this.chinaReady) return
            if (this.mapChart) this.mapChart.dispose()
            this.mapChart = echarts.init(el)
            const data = this.collegeProvinces
            const maxLesson = Math.max.apply(null, data.map(function (d) { return d.value[2] }).concat([1]))
            this.mapChart.setOption({
                tooltip: {
                    trigger: 'item',
                    confine: true,
                    backgroundColor: 'rgba(6,22,54,.92)',
                    borderColor: 'rgba(79,195,255,.5)',
                    textStyle: { color: '#cfe6ff', fontSize: 12 },
                    formatter: function (p) {
                        if (p.componentType !== 'series') return p.name
                        const d = p.data || {}
                        return '<b>' + p.name + '</b><br/>评课 ' + d.value[2] + ' 节 · 院校 ' + (d.colleges || []).length + ' 所<br/>' +
                            '<span style="color:#8fb4dd">' + (d.colleges || []).join('<br/>') + '</span>'
                    },
                },
                geo: {
                    map: 'china',
                    roam: false,
                    zoom: 1.12,
                    layoutCenter: ['50%', '52%'],
                    layoutSize: '92%',
                    itemStyle: {
                        areaColor: 'rgba(21,64,148,.45)',
                        borderColor: 'rgba(79,195,255,.5)',
                        borderWidth: 0.7,
                        shadowColor: 'rgba(21,90,210,.45)',
                        shadowBlur: 10,
                    },
                    emphasis: {
                        label: { show: false },
                        itemStyle: { areaColor: 'rgba(38,102,205,.75)' },
                    },
                },
                series: [{
                    name: '院校分布',
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    symbolSize: function (v) { return 7 + 20 * Math.sqrt((v[2] || 0) / maxLesson) },
                    rippleEffect: { brushType: 'stroke', scale: 2.6, period: 4 },
                    labelLayout: { hideOverlap: true },
                    label: {
                        show: true,
                        formatter: '{b}',
                        position: 'right',
                        distance: 6,
                        color: '#dceeff',
                        fontSize: 10,
                    },
                    itemStyle: { color: '#ffd24a', shadowBlur: 12, shadowColor: 'rgba(255,210,74,.9)' },
                    data: data,
                }],
            })
        },
        digestLessons(rows) {
            const dayOf = function (v) { return String(v || '').replace('T', ' ').slice(0, 10) }
            const yd = this.fmtDay(-1)
            let done = 0
            let ydNew = 0
            const byDay = {}
            const byDayDone = {}
            const bySubject = {}
            const teachers = {}
            rows.forEach(function (r) {
                const d = dayOf(r.createTime)
                const st = Number(r.reviewState)
                if (st === 2) {
                    done++
                    byDayDone[d] = (byDayDone[d] || 0) + 1
                }
                if (d === yd) ydNew++
                byDay[d] = (byDay[d] || 0) + 1
                const sn = r.subjectName || '未分类'
                bySubject[sn] = (bySubject[sn] || 0) + 1
                if (r.teacherName) teachers[r.teacherName] = 1
            })
            this.doneCount = done
            this.doneRate = rows.length ? ((done / rows.length) * 100).toFixed(1) : '0.0'
            this.ydNew = ydNew
            this.distinctTeachers = Object.keys(teachers).length

            const dates = []
            const counts = []
            const dones = []
            let weekNew = 0
            for (let i = 6; i >= 0; i--) {
                const d = this.fmtDay(-i)
                dates.push(d.slice(5))
                counts.push(byDay[d] || 0)
                dones.push(byDayDone[d] || 0)
                weekNew += byDay[d] || 0
            }
            this.trend = { dates: dates, counts: counts, done: dones }
            this.weekNew = weekNew

            const arr = Object.keys(bySubject).map(function (k) { return { name: k, value: bySubject[k] } })
            arr.sort(function (a, b) { return b.value - a.value })
            if (arr.length > 6) {
                let rest = 0
                arr.slice(6).forEach(function (x) { rest += x.value })
                this.subjects = arr.slice(0, 6).concat([{ name: '其他', value: rest }])
            } else {
                this.subjects = arr
            }

            const stateMap = { 2: ['已完成', 'teal'], 1: ['评课中', 'blue'], 0: ['待评课', 'amber'], '-1': ['评课失败', 'red'] }
            const sorted = rows.slice().sort(function (a, b) {
                return String(b.createTime || '').localeCompare(String(a.createTime || ''))
            })
            this.feeds = sorted.slice(0, 5).map(function (r) {
                const st = r.reviewState === null || r.reviewState === undefined ? 0 : Number(r.reviewState)
                const m = stateMap[st] || ['待评课', 'amber']
                return {
                    id: r.id,
                    teacherName: r.teacherName || '教师',
                    title: r.title || '未命名评课',
                    subjectName: r.subjectName || '',
                    pill: m[0],
                    tone: m[1],
                    time: String(r.createTime || '').replace('T', ' ').slice(5, 16),
                }
            })
        },
        renderTrend() {
            const el = this.$refs.trendChart
            if (!el) return
            if (this.trendChart) this.trendChart.dispose()
            this.trendChart = echarts.init(el)
            this.trendChart.setOption({
                grid: { left: 8, right: 12, top: 30, bottom: 0, containLabel: true },
                tooltip: { trigger: 'axis' },
                legend: {
                    data: ['评课数量', '完成数量'],
                    right: 0,
                    top: 0,
                    itemWidth: 14,
                    itemHeight: 8,
                    textStyle: { color: '#7ea6d9', fontSize: 11 },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.trend.dates,
                    axisTick: { show: false },
                    axisLine: { lineStyle: { color: 'rgba(63,156,255,.3)' } },
                    axisLabel: { color: '#7ea6d9', fontSize: 11 },
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    axisLabel: { color: '#7ea6d9', fontSize: 11 },
                    splitLine: { lineStyle: { color: 'rgba(63,156,255,.12)' } },
                },
                series: [
                    {
                        name: '评课数量',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        data: this.trend.counts,
                        lineStyle: { width: 2, color: '#4fc3ff' },
                        itemStyle: { color: '#4fc3ff', borderColor: '#fff', borderWidth: 1 },
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(79,195,255,.28)' },
                                { offset: 1, color: 'rgba(79,195,255,0)' },
                            ]),
                        },
                    },
                    {
                        name: '完成数量',
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        data: this.trend.done,
                        lineStyle: { width: 2, color: '#35e0b0', type: 'dashed' },
                        itemStyle: { color: '#35e0b0', borderColor: '#fff', borderWidth: 1 },
                    },
                ],
            })
        },
        renderSubject() {
            const el = this.$refs.subjectChart
            if (!el) return
            if (this.subjectChart) this.subjectChart.dispose()
            const w = el.clientWidth || 320
            const cx = Math.round(w * 0.36)
            this.subjectChart = echarts.init(el)
            this.subjectChart.setOption({
                color: PALETTE,
                tooltip: { trigger: 'item', formatter: '{b}：{c} 节（{d}%）' },
                legend: {
                    orient: 'vertical',
                    right: 0,
                    top: 'middle',
                    icon: 'circle',
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: { color: '#a9c6e8', fontSize: 11 },
                },
                graphic: [
                    { type: 'text', x: cx, y: 76, style: { text: String(this.lessonTotal), fill: '#ffffff', fontSize: 22, fontWeight: 500, textAlign: 'center' } },
                    { type: 'text', x: cx, y: 104, style: { text: '总评课数', fill: '#7ea6d9', fontSize: 11, textAlign: 'center' } },
                ],
                series: [
                    {
                        type: 'pie',
                        radius: ['56%', '78%'],
                        center: ['36%', '50%'],
                        data: this.subjects,
                        label: { show: false },
                        labelLine: { show: false },
                        itemStyle: { borderColor: 'rgba(7,28,66,.9)', borderWidth: 3 },
                        emphasis: { scaleSize: 6 },
                    },
                ],
            })
        },
    },
}
</script>

<style scoped lang="less">
.hpk-home {
    padding: 18px 22px 24px;
    color: #cfe6ff;
    font-size: 13px;
    min-height: 100%;
    box-sizing: border-box;

    .tc-blue { --tone: #4fc3ff; --t70: rgba(79,195,255,.7); --t45: rgba(79,195,255,.45); --t32: rgba(79,195,255,.32); --t18: rgba(79,195,255,.18); --t12: rgba(79,195,255,.12); }
    .tc-teal { --tone: #35e0b0; --t70: rgba(53,224,176,.7); --t45: rgba(53,224,176,.45); --t32: rgba(53,224,176,.32); --t18: rgba(53,224,176,.18); --t12: rgba(53,224,176,.12); }
    .tc-amber { --tone: #ffd24a; --t70: rgba(255,210,74,.7); --t45: rgba(255,210,74,.45); --t32: rgba(255,210,74,.32); --t18: rgba(255,210,74,.18); --t12: rgba(255,210,74,.12); }
    .tc-purple { --tone: #a78bfa; --t70: rgba(167,139,250,.7); --t45: rgba(167,139,250,.45); --t32: rgba(167,139,250,.32); --t18: rgba(167,139,250,.18); --t12: rgba(167,139,250,.12); }
    .tc-coral { --tone: #ff8a5c; --t70: rgba(255,138,92,.7); --t45: rgba(255,138,92,.45); --t32: rgba(255,138,92,.32); --t18: rgba(255,138,92,.18); --t12: rgba(255,138,92,.12); }
    .tc-red { --tone: #ff6b6b; --t70: rgba(255,107,107,.7); --t45: rgba(255,107,107,.45); --t32: rgba(255,107,107,.32); --t18: rgba(255,107,107,.18); --t12: rgba(255,107,107,.12); }

    .hh-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        font-weight: 500;
        color: #dceeff;
        letter-spacing: 1px;
        padding-bottom: 8px;
        margin: 0 0 14px;
        border-bottom: 1px solid rgba(63, 156, 255, 0.35);

        &.hh-sm {
            font-size: 14px;
            margin-bottom: 8px;
        }

        &::before {
            content: '';
            width: 8px;
            height: 8px;
            background: #3f9cff;
            transform: rotate(45deg);
            box-shadow: 0 0 8px #3f9cff;
        }

        .more {
            margin-left: auto;
            font-size: 12px;
            color: #5f8fd0;
            cursor: pointer;
            font-weight: 400;

            &:hover {
                color: #4fc3ff;
            }
        }
    }

    .hh-banner {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(90deg, rgba(24, 80, 190, 0.5), rgba(10, 35, 90, 0.2) 70%);
        border: 1px solid rgba(63, 156, 255, 0.35);
        border-radius: 10px;
        padding: 20px 26px;
        margin-bottom: 14px;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background: linear-gradient(90deg, #4fc3ff, #35e0b0, #ffd24a, #ff8a5c, transparent);
            box-shadow: 0 0 12px rgba(79, 195, 255, 0.6);
        }

        .hh-hi h2 {
            font-size: 20px;
            font-weight: 500;
            color: #eaf6ff;
            letter-spacing: 1px;
            text-shadow: 0 0 12px rgba(64, 156, 255, 0.7);
            margin: 0 0 6px;
        }

        .hh-hi p {
            font-size: 13px;
            color: #8fb4dd;
            margin: 0;

            b {
                color: #ffd24a;
                font-weight: 500;
            }
        }

        .hh-date {
            text-align: right;
            font-size: 12px;
            color: #7ea6d9;
            line-height: 1.8;

            .big {
                font-size: 22px;
                color: #eaf6ff;
                font-family: 'DIN Alternate', 'Segoe UI', sans-serif;
            }
        }
    }

    .hh-card {
        background: linear-gradient(180deg, rgba(13, 40, 95, 0.35), rgba(5, 18, 45, 0.55));
        border: 1px solid rgba(63, 156, 255, 0.28);
        border-radius: 8px;
        padding: 14px 16px;
        box-shadow: inset 0 0 24px rgba(20, 70, 170, 0.15);
    }

    .hh-grid {
        display: grid;
        grid-template-columns: 4.5fr 5fr 4.5fr;
        gap: 14px;
        margin-bottom: 16px;
    }

    .hh-chart {
        height: 210px;
    }

    .hh-empty {
        padding: 20px 0;
        text-align: center;
        color: #5f8fd0;
        font-size: 12px;
    }

    .hh-kpis {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 14px;
        margin-bottom: 14px;
    }

    .hh-kpi {
        display: flex;
        align-items: center;
        gap: 14px;
        border-radius: 8px;
        padding: 13px 18px;
        position: relative;
        overflow: hidden;
        background: linear-gradient(180deg, rgba(16, 55, 130, 0.35), rgba(8, 25, 60, 0.35));
        border: 1px solid var(--t45);
        box-shadow: inset 0 0 20px var(--t12);

        &::before {
            content: '';
            position: absolute;
            right: -30px;
            top: -30px;
            width: 90px;
            height: 90px;
            border-radius: 50%;
            background: radial-gradient(circle, var(--t18), transparent 70%);
        }

        .hh-ring {
            flex: none;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: radial-gradient(circle, var(--t32), rgba(8, 25, 60, 0.9));
            border: 1px solid var(--t70);
            box-shadow: 0 0 14px var(--t45), inset 0 0 12px var(--t12);
        }

        .hh-label {
            font-size: 12px;
            color: #7ea6d9;
            margin-bottom: 3px;
        }

        .hh-value {
            font-size: 24px;
            font-weight: 500;
            font-family: 'DIN Alternate', 'Segoe UI', sans-serif;
            background-image: linear-gradient(180deg, #ffffff, var(--tone));
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;

            small {
                font-size: 12px;
                margin-left: 3px;
            }
        }

        .hh-trend {
            font-size: 11px;
            margin-top: 2px;
            color: var(--tone);
        }
    }

    .hh-entries {
        display: grid;
        grid-template-columns: repeat(6, minmax(0, 1fr));
        gap: 12px;
        margin-bottom: 16px;
    }

    .hh-entry {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 18px 10px 15px;
        border-radius: 8px;
        cursor: pointer;
        text-align: center;
        background: linear-gradient(180deg, rgba(16, 55, 130, 0.35), rgba(8, 25, 60, 0.35));
        border: 1px solid var(--t45);
        transition: all 0.2s;

        &:hover {
            transform: translateY(-3px);
            border-color: var(--tone);
            box-shadow: 0 6px 18px var(--t32), inset 0 0 18px var(--t12);
        }

        .hh-eico {
            width: 42px;
            height: 42px;
            border-radius: 11px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--t18);
            border: 1px solid var(--t45);
            box-shadow: 0 0 12px var(--t32), inset 0 0 10px var(--t12);
        }

        .hh-ename {
            font-size: 13px;
            color: #dceeff;
        }

        .hh-enum {
            font-size: 11px;
            color: var(--tone);
            font-family: Consolas, monospace;
        }
    }

    .hh-feed-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 11px 4px;
        border-bottom: 1px solid rgba(63, 156, 255, 0.12);
        font-size: 13px;

        &:last-child {
            border-bottom: none;
        }

        .dot {
            flex: none;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: var(--tone);
            box-shadow: 0 0 8px var(--tone);
        }

        .txt {
            flex: 1;
            color: #c4dcf5;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            b {
                color: #eaf6ff;
                font-weight: 500;
            }
        }

        .pill {
            flex: none;
            font-size: 11px;
            padding: 1px 9px;
            border-radius: 9px;
            color: var(--tone);
            border: 1px solid var(--t45);
            background: var(--t12);
        }

        .time {
            flex: none;
            font-size: 12px;
            color: #5f8fd0;
            font-family: Consolas, monospace;
        }
    }

    @media (max-width: 1500px) {
        .hh-kpis {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        .hh-entries {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}
</style>
